// extracted by mini-css-extract-plugin
export default {"appHeader":"header_appHeader__blm+f","appHeaderBar":"header_appHeaderBar__pf-Qi","appName":"header_appName__+edYI","highlight":"header_highlight__lGU11"};